/* tslint:disable */
/* eslint-disable */
/**
 * Juhsis REST Service API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { LatestPricesResponse } from '../models';
/**
 * MarketDataApi - axios parameter creator
 * @export
 */
export const MarketDataApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Retrieve extended-hours-aware latest prices for a comma-separated list of ticker symbols (used by the Trading 212 ISA page positions). Prices are derived from Polygon\'s multi-ticker snapshot in a single call and cached server-side for 30 seconds. Unknown or unsupported tickers are simply absent from the response.
         * @summary Get batched latest prices for tickers
         * @param {string} tickers 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestPrices: async (tickers: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tickers' is not null or undefined
            assertParamExists('getLatestPrices', 'tickers', tickers)
            const localVarPath = `/api/market-data/latest-prices`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (tickers !== undefined) {
                localVarQueryParameter['tickers'] = tickers;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MarketDataApi - functional programming interface
 * @export
 */
export const MarketDataApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MarketDataApiAxiosParamCreator(configuration)
    return {
        /**
         * Retrieve extended-hours-aware latest prices for a comma-separated list of ticker symbols (used by the Trading 212 ISA page positions). Prices are derived from Polygon\'s multi-ticker snapshot in a single call and cached server-side for 30 seconds. Unknown or unsupported tickers are simply absent from the response.
         * @summary Get batched latest prices for tickers
         * @param {string} tickers 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestPrices(tickers: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<LatestPricesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestPrices(tickers, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['MarketDataApi.getLatestPrices']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * MarketDataApi - factory interface
 * @export
 */
export const MarketDataApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MarketDataApiFp(configuration)
    return {
        /**
         * Retrieve extended-hours-aware latest prices for a comma-separated list of ticker symbols (used by the Trading 212 ISA page positions). Prices are derived from Polygon\'s multi-ticker snapshot in a single call and cached server-side for 30 seconds. Unknown or unsupported tickers are simply absent from the response.
         * @summary Get batched latest prices for tickers
         * @param {string} tickers 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestPrices(tickers: string, options?: RawAxiosRequestConfig): AxiosPromise<LatestPricesResponse> {
            return localVarFp.getLatestPrices(tickers, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MarketDataApi - object-oriented interface
 * @export
 * @class MarketDataApi
 * @extends {BaseAPI}
 */
export class MarketDataApi extends BaseAPI {
    /**
     * Retrieve extended-hours-aware latest prices for a comma-separated list of ticker symbols (used by the Trading 212 ISA page positions). Prices are derived from Polygon\'s multi-ticker snapshot in a single call and cached server-side for 30 seconds. Unknown or unsupported tickers are simply absent from the response.
     * @summary Get batched latest prices for tickers
     * @param {string} tickers 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MarketDataApi
     */
    public getLatestPrices(tickers: string, options?: RawAxiosRequestConfig) {
        return MarketDataApiFp(this.configuration).getLatestPrices(tickers, options).then((request) => request(this.axios, this.basePath));
    }
}

